import styled from 'styled-components'

const AppWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`

export default AppWrapper
